<div class="contenedor-menu-burguer" id="contenedor-menu-burguer" [style]="{ '--clor-boton-burguer': configBloque?.color_menu, '--color-texto-boton-burguer': configBloque?.color_texto_menu, '--background-menu-color-movil': configBloque?.color_fondo_movil, '--background-menu-color': configBloque?.color_fondo, '--accent-color': globalConstants?.accent_color }">
  <nav class="nav-menu-burguer">
    <ng-container *ngIf="!isInIframe">
      <div class="nav-3-columns">
        <button #burgerButton class="menu-burguer-btn" (click)="openSidenav()" aria-label="menu"><app-icon-menu-burguer></app-icon-menu-burguer> <span>Menú</span></button>

        <ng-container *ngIf="showSidenavMenu">
          <app-sidenav-menu-burguer class="sidenav-menu"></app-sidenav-menu-burguer>
        </ng-container>

        <ng-container *ngIf="showBuscador">
          <div id="buscador" class="buscador" (click)="mostrarBuscador = !mostrarBuscador">
            <app-icon-search></app-icon-search>
            <span class="txt-buscador"> Buscador</span>
          </div>
          <ng-container *ngIf="mostrarBuscador">
            <div [@slideInOut] class="container-buscador">
              <form class="form-buscador" #searchForm="ngForm" (ngSubmit)="enviarBusqueda(searchForm.value)">
                <div (click)="mostrarBuscador = !mostrarBuscador">
                  <app-icon-close [color]="'#fff'"></app-icon-close>
                </div>
                <input #buscador type="text" name="buscar" class="form-buscador" placeholder="Escriba para buscar..." ngModel />
                {{ buscador.focus() }}
                <span (click)="enviarBusqueda(searchForm.value)">Buscar</span>
              </form>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="showRadio"
          ><!-- esto creo que no se usa -->
          <div class="radio">
            <audio #audioRadio src="https://streams.radio.co/se18e1e587/listen"></audio>
            <span class="buscador">
              <span class="icon-circle animate-flicker"></span>
              <span class="radioTxt">Radio en directo </span>
              <ng-container *ngIf="!boolAudio">
                <span class="play-radio" (click)="playPause()"><app-icon-play color="#fff"></app-icon-play></span>
              </ng-container>
              <ng-container *ngIf="boolAudio">
                <span class="play-radio" (click)="playPause()"><app-icon-pause color="#fff"></app-icon-pause></span>
              </ng-container>
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="show24h">
          <div class="noticias24hrs">
            <a [routerLink]="'noticias-24-horas'" class="buscador news-24hours">
              <span class="icon-circle animate-flicker"></span>
              <span class="radioTxt">Noticias 24h </span>
            </a>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="isInIframe">
      <div class="nav-3-columns"></div>
    </ng-container>

    <ng-container *ngIf="!constantesGlobales?.isNews && showParteCentral">
      <div class="nav-4-columns" [innerHTML]="parteCentralContent"></div>
    </ng-container>

    <a routerLink="/" [state]="{ origin: 'Logo' }" class="logo-mobile">
      <app-skeleton-image [src]="urlLogoMovil" [alt]="'Logo app'" [aspectRatio]="'2.7'" [customClass]="'logo-mobile-img'"></app-skeleton-image>
    </a>
    <div class="nav-login">
      <ng-container *ngIf="showContacto">
        <!-- esto creo que no se usa -->
        <a [href]="urlContacto" class="nav-contacto" [attr.target]="contactoExterno ? '_blank' : null">
          <app-icon-email [color]="'#000'"></app-icon-email>
        </a>
      </ng-container>
      <ng-container *ngIf="!isInIframe && showLogin">
        <div id="login" class="login">
          <ng-container *ngIf="!userLogin; else showLoged">
            <div class="container-login">
              <button class="btn-sesion" title="Iniciar Sesión" (click)="this.showLoginModal = !this.showLoginModal">
                <span class="txt-login">Iniciar Sesión</span>
              </button>
            </div>
            <ng-container *ngIf="isRegistroExterno">
              <!-- esto no se si se usa -->
              <div class="container-register">
                <a [href]="enlaceRegistroExterno" target="_blank">
                  <button class="register-btn">
                    <span class="txt-login">Registrarse</span>
                  </button>
                </a>
              </div>
              <div class="icon-login">
                <a [href]="enlaceRegistroExterno">
                  <app-icon-app-registration></app-icon-app-registration>
                </a>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #showLoged>
            <div>Bienvenido,</div>
            <button class="btn-login" (click)="showLogOutOption = !showLogOutOption">{{ userLogin.nombre }} {{ userLogin.apellidos }}</button>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </nav>
  <ng-container *ngIf="showLogOutOption">
    <div class="logOut--container">
      <button class="logOut--button" (click)="logout()"><span>Cerrar sesión</span></button>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="showLoginModal">
  <app-modal-login (closeModal)="this.showLoginModal = !this.showLoginModal"></app-modal-login>
</ng-container>
